module.exports = __webpack_public_path__ + "img/12.e2e191e4.png";